import type { CoachProgrammationApiGateway } from "@/modules/coachProgrammation/gateway/coachProgrammationApi.gateway"
import {
  CoachProgrammationDetailsDtoSchema,
  CoachProgrammationItemDtoSchema,
  type CoachProgrammationDetailsDto,
  type CoachProgrammationItemDto,
  type CreateCoachProgrammationInputDto,
  type UpdateCoachProgrammationInputDto,
} from "@/modules/coachProgrammation/gateway/coachProgrammationDto"
import { ApiClient } from "@modules/core/api/client/apiClient"

export class CoachProgrammationApi implements CoachProgrammationApiGateway {
  private baseUrl = "/pro/programmation"

  constructor(private api: ApiClient) {}

  async getCoachProgrammations(): Promise<CoachProgrammationItemDto[]> {
    const result = await this.api.get<CoachProgrammationItemDto[]>(this.baseUrl)
    return result.data.map((dto) => CoachProgrammationItemDtoSchema.parse(dto))
  }

  async getCoachProgrammation(id: string): Promise<CoachProgrammationDetailsDto> {
    const result = await this.api.get<CoachProgrammationDetailsDto>(`${this.baseUrl}/${id}`)
    return CoachProgrammationDetailsDtoSchema.parse(result.data)
  }

  async createCoachProgrammation(input: CreateCoachProgrammationInputDto): Promise<CoachProgrammationDetailsDto> {
    const result = await this.api.post<CoachProgrammationDetailsDto>(this.baseUrl, input)
    return CoachProgrammationDetailsDtoSchema.parse(result.data)
  }

  async updateCoachProgrammation(
    id: string,
    input: UpdateCoachProgrammationInputDto,
  ): Promise<CoachProgrammationDetailsDto> {
    const result = await this.api.put<CoachProgrammationDetailsDto>(`${this.baseUrl}/${id}`, input)
    return CoachProgrammationDetailsDtoSchema.parse(result.data)
  }

  async deleteCoachProgrammation(id: string): Promise<void> {
    await this.api.delete(`${this.baseUrl}/${id}`)
  }
}
